<template>


        <input name="comment-author-input" class="comment-details-input comment-blck-top" :id="'comment-author-input-'+post_id+'-sum-'+summaryNum" placeholder="Your name (required)" />
        <input name="comment-author-email-input" class="comment-details-input" :id="'comment-author-email-input-'+post_id+'-sum-'+summaryNum" placeholder="Your email (optional)"/>
        <textarea name="comment-input" class="comment-input" :id="'comment-input-'+post_id+'-sum-'+summaryNum" placeholder="Please share your thoughts. Your opinion is valuable."></textarea>  

</template>


<script>
export default {
  name: "SummaryCommentForm",
  props: ['post_id','addedComments','submitCommentParent','summary'],
  data() {
    return {
      postId: this.post_id,
      addedCommentsArray: this.addedComments,
      summaryNum: this.summary
    };
  }  


};
</script>